import { Col, Form } from "react-bootstrap";
import style from "./AddressForm.module.css";
import RowUi from "../../Ui/RowUi";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { Fragment, useEffect, useState } from "react";
import getCountries from "../functions/getCountries";

function AddressForm({ personType, errors, register, control, unregister }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getCountries(data => setCountries(() => data));
  }, []);

  useEffect(() => {
    if (personType === 0) {
      unregister("company");
      unregister("enCompany");
    } else {
      unregister("name");
      unregister("enName");
      unregister("family");
      unregister("enFamily");
    }
  }, [personType]);

  return (
    <div className={"d-flex flex-wrap mt-2 " + style.box}>
      {personType === 0 && (
        <Fragment>
          <RowUi>
            <Col xs={12} lg={6}>
              <Form.Label>
                <span>نام</span>
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control type="text" {...register("name")} />
              {errors.name?.type === "required" && <p>{errors.name.message}</p>}
            </Col>
            <Col xs={12} lg={6} className={style.ltr}>
              <Form.Label>
                <span>Name</span>
              </Form.Label>
              <Form.Control type="text" {...register("enName")} />
            </Col>
          </RowUi>

          <RowUi>
            <Col xs={12} lg={6}>
              <Form.Label>
                <span>نام خانوادگی</span>
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control type="text" {...register("family")} />
              {errors.family?.type === "required" && (
                <p>{errors.family.message}</p>
              )}
            </Col>
            <Col xs={12} lg={6} className={style.ltr}>
              <Form.Label>
                <span>Family</span>
              </Form.Label>
              <Form.Control type="text" {...register("enFamily")} />
            </Col>
          </RowUi>
        </Fragment>
      )}

      {personType === 1 && (
        <RowUi>
          <Col xs={12} lg={6}>
            <Form.Label>
              <span>نام شرکت</span>
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="text" {...register("company")} />
            {errors.company?.type === "required" && (
              <p>{errors.company.message}</p>
            )}
          </Col>
          <Col xs={12} lg={6} className={style.ltr}>
            <Form.Label>
              <span>Company Name</span>
            </Form.Label>
            <Form.Control type="text" {...register("enCompany")} />
          </Col>
        </RowUi>
      )}

      <Col xs={12} md={5} lg={3}>
        <Form.Label>
          <span>موبایل</span>
          <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control type="number" {...register("phone")} />
        {errors.phone?.type === "required" && <p>{errors.phone.message}</p>}
      </Col>

      <Col xs={12} md={5} lg={3}>
        <Form.Label>
          <span>تلفن</span>
        </Form.Label>
        <Form.Control type="number" {...register("tel")} />
      </Col>

      <Col xs={12} md={5} lg={3}>
        <Form.Label>
          <span>کد پستی</span>
        </Form.Label>
        <Form.Control type="text" {...register("postCode")} />
      </Col>

      <Col xs={12} md={5} lg={3}>
        <Form.Label>
          <span>ایمیل</span>
        </Form.Label>
        <Form.Control type="text" {...register("email")} />
      </Col>

      <Col xs={12} md={5}>
        <Form.Label>
          <span>کشور</span>
          <span className="text-danger">*</span>
        </Form.Label>

        <Controller
          control={control}
          defaultValue={0}
          name="country"
          render={({ field: { onChange, value, ref } }) => (
            <Select
              inputRef={ref}
              className={style.country}
              classNamePrefix="dir-farsi "
              options={countries}
              value={countries.find(c => c.value === value)}
              onChange={val => {
                onChange(val.value);
              }}
            />
          )}
        />
        {errors.country?.type === "required" && <p>{errors.country.message}</p>}
        {errors.country?.type === "min" && <p>{errors.country.message}</p>}
      </Col>

      <RowUi>
        <Col xs={12} lg={6}>
          <Form.Label>
            <span>شهر</span>
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control type="text" {...register("city")} />
          {errors.city?.type === "required" && <p>{errors.city.message}</p>}
        </Col>

        <Col xs={12} lg={6} className={style.ltr}>
          <Form.Label>
            <span>City</span>
          </Form.Label>
          <Form.Control type="text" {...register("enCity")} />
        </Col>
      </RowUi>

      <RowUi>
        <Col xs={12} lg={6}>
          <Form.Label>
            <span>آدرس</span>
            <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control as="textarea" {...register("address")} />
          {errors.address?.type === "required" && (
            <p>{errors.address.message}</p>
          )}
        </Col>

        <Col xs={12} lg={6} className={style.ltr}>
          <Form.Label>
            <span>Address</span>
          </Form.Label>
          <Form.Control as="textarea" {...register("enAddress")} />
        </Col>
      </RowUi>
    </div>
  );
}

export default AddressForm;
